export function getStoreLinks(store, row) {
  const storeProductPage = {
    amazon: row?.["supply"]["supply_asin"]
      ? `https://www.amazon.com/gp/offer-listing/${row?.["supply"]["supply_asin"]}/ref=olp_f_freeShipping?ie=UTF8&f_freeShipping=true&f_new=true`
      : `https://www.amazon.com/s/ref=nb_sb_noss?url=search-alias%3Daps&field-keywords=${row?.["supply"]["supply_asin"]}`,
    amazonca: row?.["supply"]["supply_asin"]
      ? `https://www.amazon.ca/gp/offer-listing/${row?.["supply"]["supply_asin"]}/ref=olp_f_freeShipping?ie=UTF8&f_new=true`
      : `https://www.amazon.ca/s/ref=nb_sb_noss?url=search-alias%3Daps&field-keywords=${row?.["supply"]["supply_asin"]}&fap=1`,
    amazonuk: `https://www.amazon.co.uk/s/ref=nb_sb_noss?url=search-alias%3Daps&field-keywords=${row?.["supply"]["supply_asin"]}`,
    alliance: `https://webami.aent.com/${row?.["supply"]["upc"]}`,
    barnesandnoble: `https://www.barnesandnoble.com/s/${row?.["supply"]["upc"]}`,
    bestbuy: `https://www.bestbuy.com/site/searchpage.jsp?st=${row?.["supply"]["upc"]}&_dyncharset=UTF-8&id=pcat17071`,
    blowitoutahere: `https://www.blowitoutahere.com/${row?.["supply"]["upc"]}`,
    bookdepo: `https://www.bookdepository.com/a/${row?.["supply"]["upc"]}`,
    bullmoose: `https://www.bullmoose.com/search?q=${row?.["supply"]["upc"]}`,
    camel: `https://camelcamelcamel.com/search?sq=${row?.["supply"]["upc"]}`,
    ccvideo: `https://www.ccvideo.com/${row?.["supply"]["upc"]}`,
    "collectors choice music": `https://www.ebay.com/sch/i.html?_dkr=1&iconV2Request=true&_blrs=recall_filtering&_ssn=collectorschoicemusic&store_cat=0&store_name=getimportcds&_oac=1&_nkw=${row?.["supply"]["upc"]}`,
    chapters: `https://www.chapters.indigo.ca/en-ca/home/search/?keywords=${row?.["supply"]["upc"]}#facetIds=321011`,
    "couch potato": `https://www.couchpotato.com/store/search/?q=${row?.["supply"]["upc"]}`,
    deepdiscount: `https://www.deepdiscount.com/${row?.["supply"]["upc"]}`,
    dealsareus: `https://b2b.dealsareus.ca/${row?.["supply"]["upc"]}`,
    ebayv1: [
      `https://www.ebay.com/sch/i.html?_from=R40&_nkw=${row?.["supply"]["upc"]}
      &LH_TitleDesc=0&_sac=1&_sop=15&_fsrp=1&LH_All=1&_oac=1&rt=nc&LH_ItemCondition=2`,
      `https://www.ebay.com/sch/i.html?_from=R40&_nkw=${row?.["supply"]["upc"]}&LH_TitleDesc=0&_sac=1&_sop=15&_fsrp=1&LH_All=1&_oac=1&rt=nc&LH_ItemCondition=3`,
    ],
    ebayblowit: `https://www.ebay.com/sch/i.html?_dkr=1&iconV2Request=true&_ssn=pop.market&store_cat=0&store_name=blowitoutahere&_oac=1&_nkw=${row?.["supply"]["upc"]}`,
    familyvideo: `https://www.familyvideo.com/catalog/product_info.php?products_id=${row?.["supply"]["upc"]}`,
    frys: `https://www.frys.com/search?resultpage=0&start=0&rows=25&pType=pDisplay&cat=-68984&inq=${row?.["supply"]["upc"]}`,
    heartland: `https://www.heartlandmusic.com/${row?.["supply"]["upc"]}`,
    gruv: `https://www.ebay.com/sch/i.html?_dkr=1&iconV2Request=true&_ssn=gruv-entertainment&store_cat=0&store_name=gruventertainment&_oac=1&_nkw=${row?.["supply"]["upc"]}`,
    importcds: `https://www.importcds.com/${row?.["supply"]["upc"]}`,
    importcdsebay: `https://www.ebay.com/sch/i.html?_dkr=1&iconV2Request=true&_ssn=get_importcds&store_cat=0&store_name=getimportcds&_oac=1&_nkw=${row?.["supply"]["upc"]}`,
    mila: `https://milavideo.com/index.php?fc=module&module=czproductsearch&controller=productsearch&cate=&search_query=${row?.["supply"]["upc"]}`,
    rarewaves: `https://www.rarewaves.com/pages/search-results?type=product&q=${row?.["supply"]["upc"]}`,
    rakuten: `https://www.rakuten.com/sr/searchresults#qu=${row?.["supply"]["upc"]}"&rt=1&page=1`,
    rightstuf: `https://www.rightstufanime.com/search?keywords=${row?.["supply"]["upc"]}`,
    target: `https://www.target.com/s?searchTerm=${row?.["supply"]["upc"]}`,
    walmart: `https://www.walmart.com/ip/${row?.["supply"]["walsku"]}`,
    walmartca: `https://walmart.ca/search/${row?.["supply"]["walsku"]}`,
    wowhd: `https://www.wowhd.us/${row?.["supply"]["upc"]}`,
  };

  return storeProductPage[store];
}

// const storeHomePage = {
//   amazon: "https://www.amazon.com",
//   amazonca: "https://www.amazon.ca/",
//   amazonuk: "https://www.amazon.co.uk",
//   alliance: "https://webami.aent.com/",
//   barnesandnoble: "https://www.barnesandnoble.com/",
//   bestbuy: "https://www.bestbuy.com/",
//   blowitoutahere: "https://blowitoutahere.com",
//   bookdepo: "https://www.bookdepository.com/",
//   bullmoose: "https://www.bullmoose.com/",
//   camel: "https://camelcamelcamel.com/",
//   ccvideo: "https://www.ccvideo.com/",
//   chapters: "https://www.chapters.indigo.ca/",
//   "couch potato": "https://www.couchpotato.com/",
//   deepdiscount: "https://www.deepdiscount.com/",
//   dealsareus: "https://b2b.dealsareus.ca/",
//   ebayv1: "https://www.ebay.com/",
//   ebayblowit: "https://stores.ebay.com/Blowitoutahere",
//   familyvideo: "https://www.familyvideo.com/",
//   frys: "https://www.frys.com/",
//   gruv: "https://www.ebay.com/str/gruventertainment",
//   heartland: "https:/heartlandmusic.com/",
//   importcds: "https://www.importcds.com/",
//   importcdsebay: "https://stores.ebay.com/get-importCDs/",
//   rarewaves: "https://rarewaves.com/",
//   rakuten: "https://www.rakuten.com/",
//   rightstuf: "https://www.rightstufanime.com/",
//   target: "https://target.com/",
//   mila: "https://milavideo.com/",
//   walmart: "https://www.walmart.com/",
//   walmartca: "https://walmart.ca/",
//   wowhd: "https://www.wowhd.us/",
// };
